import '../scss/seller-harness.scss';

import {initHarnessFooter} from './seller-harness-footer.js';
import {initContactForms} from './contact-form.js';
import {initI18n} from './i18n.js';
import {commonTranslations} from './translations/common.js';
import {sellerHarnessTranslations} from './translations/seller-harness.js';

const GA4_MEASUREMENT_ID = 'G-C0F47YH973';
const PAGE_NAME = 'seller';

function pushGa4Event(eventName, payload = {}) {
  window.loadLoyolAnalytics?.();
  window.dataLayer = window.dataLayer || [];

  function gtagCommand() {
    window.dataLayer.push(arguments);
  }

  gtagCommand('event', eventName, {
    send_to: GA4_MEASUREMENT_ID,
    transport_type: 'beacon',
    page: PAGE_NAME,
    campaign_intent: PAGE_NAME,
    ...payload,
  });
}

function pushSellerEvent(payload) {
  const {event, ...eventParams} = payload;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    page: PAGE_NAME,
    campaign_intent: PAGE_NAME,
    ...payload,
  });

  if (event) {
    pushGa4Event(event, eventParams);
  }
}

function initTracking() {
  document.querySelectorAll('[data-track-event]').forEach((link) => {
    link.addEventListener('click', () => {
      const payload = {
        event: link.dataset.trackEvent,
        placement: link.dataset.trackPlacement || '',
        destination: link.dataset.trackDestination || '',
        campaign_intent: link.dataset.trackIntent || PAGE_NAME,
        label: link.textContent.trim().replace(/\s+/g, ' '),
      };

      pushSellerEvent(payload);

      if (payload.destination === 'contact_form') {
        pushSellerEvent({
          event: 'lead_intent',
          placement: payload.placement,
          destination: payload.destination,
          campaign_intent: payload.campaign_intent,
        });

      }
    });
  });
}

function initRevealAnimations() {
  const revealElements = document.querySelectorAll('.reveal');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealElements.forEach((element) => element.classList.add('is-visible'));
    return;
  }

  document.documentElement.classList.add('harness-js');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    rootMargin: '0px 0px -8% 0px',
    threshold: 0.08,
  });

  revealElements.forEach((element) => observer.observe(element));
}

initHarnessFooter();
initI18n(commonTranslations, sellerHarnessTranslations);
initTracking();
initRevealAnimations();
initContactForms({
  pageName: PAGE_NAME,
  campaignIntent: PAGE_NAME,
  pushEvent: pushSellerEvent,
  pushGa4Event,
});
